/** Validation message shown under the input that produced it. */
export function FieldError({ message }) {
  if (!message) return null;
  return <p className="text-xs text-red-600">{message}</p>;
}
